import React from 'react'
import { MailSettingsInstance } from '../../../../common/types/api/report'
import { cronToDate, dateToCron } from '../SchedulingHelper'
import i18n from 'live/services/i18n'
import Toggle from '../../../../common/components/SimpleInputs/Toggle'
import { ExecutionText } from './ExecutionText'
import moment from 'moment'

export enum ScheduleType {
    Date = 0,
    Recurrent = 1,
    Rule = 2
}

export function getScheduleType(settings: MailSettingsInstance): ScheduleType {
    if (settings?.isRuleAlarm) {
        return ScheduleType.Rule
    } else if (settings?.isRecurrent) {
        return ScheduleType.Recurrent
    } else {
        return ScheduleType.Date
    }
}

export function getScheduleOptions(): ScheduleType[] {
    return Object.keys(ScheduleType)
        .filter(key => isFinite(parseInt(key)))
        .map(key => parseInt(key))
}

export function setScheduleTypeInMailSettingsInstance(
    scheduleType: ScheduleType,
    mailSettings: MailSettingsInstance
): MailSettingsInstance {
    return {
        ...mailSettings,
        isRecurrent: scheduleType == ScheduleType.Recurrent,
        isRuleAlarm: scheduleType == ScheduleType.Rule,
        cron: ScheduleType.Recurrent == scheduleType ? '0 0 * * *' : dateToCron(new Date())
    }
}

export function getScheduleTypeName(scheduleType: ScheduleType): string {
    switch (scheduleType) {
        case ScheduleType.Recurrent:
            return 'Recurrent'
        case ScheduleType.Date:
            return 'One Time'
        case ScheduleType.Rule:
            return 'Alarm Rule'
    }
}

export function getNameMailSettingsInstance(settings: MailSettingsInstance): string {
    if (!!settings?.name) return settings.name
    return ''
}

export function getFrequencyMailSettingsInstance(settings: MailSettingsInstance): string | JSX.Element {
    if (settings.isRuleAlarm)
        return <ExecutionText ruleAlarm text="Executed at" value={settings.ruleId} textColor="green" />
    if (settings.isRecurrent)
        return (
            <ExecutionText
                text="Next execution at"
                value={cronToDate(settings.cron).toLocaleString()}
                textColor="blue"
            />
        )

    return (
        <ExecutionText
            text="Executed at"
            value={cronToDate(settings.cron).toLocaleString()}
            textColor="green"
        />
    )
}

export function getStatusMailSettingsInstance(
    settings: MailSettingsInstance,
    onChange: (mailSettings: MailSettingsInstance) => void
): JSX.Element {
    return (
        <div className="toggleStatus">
            <Toggle
                value={settings.active}
                onChange={value => {
                    const newSettings = { ...settings }
                    newSettings.active = value
                    onChange(newSettings)
                }}
                titleComponent={<span>{i18n(`${settings.active ? 'Active' : 'Inactive'}`)}</span>}
            />
        </div>
    )
}

export function getScheduleMailSettingsInstance(settings: MailSettingsInstance): string {
    return getScheduleTypeName(getScheduleType(settings))
}
